import Button from 'components/Button'
import Control from 'components/Control/Control'
import UploadIcon from 'components/icons/UploadIcon'
import React, { Fragment } from 'react'
import ErrorMessage from 'utils/ErrorMessage'

import {
  AddIcon,
  Cirlcle,
  SmallButtons,
  SpanText,
  StyledH2,
  StyledUpload,
  TextWrapper,
  UploadText,
  Wrapper,
} from 'components/Uploader/Styles'
import Add from 'components/icons/Add'
import { deleteFile, uploadFile } from 'modules/Drive/actions'
import { useDispatch } from 'react-redux'

const Uploader = ({
  isDelete,
  file,
  setFile,
  isDefault = false,
  isImage = false,
  showTextUploder,
  showButtonUploder,
  fileName,
  format,
  setIsLoading,
  bgcolor='#fafafb',
  borderColor='#cccfd6',
  height = 'auto',
}) => {
  const dispatch = new useDispatch()

  const getFileUrl = async info => {
    let getType = info?.file?.type?.includes('xlsx') ? 'xlsx' : 'csv'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.xlsx',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (!file?.type.includes('xlsx') && !file?.type.includes('csv')) {
        ErrorMessage('File should be in xlsx/csv  format!')
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info)
      }
    },
    itemRender: () => {},
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onBeforeUpload = file => {
    const isLt10mb = file.size / 1024 / 1024 < 10
    if (!isLt10mb) {
      ErrorMessage('File must smaller than 10mb!')
      return false
    } else if (!file?.type?.includes('spreadsheetml')) {
      ErrorMessage('File should be in xlsx/csv  format!')
      return false
    }
  }

  const onBeforeUpload1 = file => {
    const isLt10mb = file.size / 1024 / 1024 < 10
    if (!isLt10mb) {
      ErrorMessage('Image must smaller than 10mb!')
      return false
    } else if (!(file?.type?.includes('png') || file?.type?.includes('jpeg'))) {
      ErrorMessage('File should be in jpg/jpeg or png format!')
      return false
    }
  }

  const onChangeFileUpload = async info => {
    if (info?.file?.status === 'done') {
      setIsLoading(true)
      let getType = info?.file?.type?.includes('spreadsheetml') ? 'xlsx' : 'csv'
      let name = fileName + '.' + getType
      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(fileObject)
      }
    }
  }

  const getFileUrl1 = async info => {
    let getType = info?.file?.type?.includes('png') ? 'png' : 'jpg'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }
  const onChangeFileUpload1 = async info => {
    if (info?.file?.status === 'done') {
      let getType = info?.file?.type?.includes('png') ? 'png' : 'jpg'
      let name = fileName + '.' + getType
      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(fileObject)
      }
    }
  }

  const props1 = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.jpeg, .jpg , .png',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (
        !(file?.type.includes('png') || file?.type?.includes('jpeg'))
      ) {
        ErrorMessage('File should be in jpg/jpeg or png format!')
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl1(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl1(info)
      }
    },
    itemRender: () => {},
  }

  return (
    <Fragment>
      {isDefault && (
        <Wrapper bgcolor={bgcolor} borderColor={borderColor} height={height}>
          <StyledUpload
            {...props}
            type="file"
            accept={'.xlsx'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload}
            beforeUpload={onBeforeUpload}
            maxCount={1}
            drag
          >
            <SmallButtons
              icon={<UploadIcon />}
            />
            <TextWrapper>
              <StyledH2>Browse for file or Drag and drop</StyledH2>
            </TextWrapper>
            <TextWrapper>
              <SpanText>Format {format ? format : '.xlsx'}</SpanText>
            </TextWrapper>
          </StyledUpload>
        </Wrapper>
      )}
      {isImage && (
        <Wrapper center alignCenter column>
          <StyledUpload
            {...props1}
            type="file"
            accept={'.jpeg, .jpg ,.png'}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload1}
            beforeUpload={onBeforeUpload1}
          >
            <SmallButtons
              height={'38px'}
              width="38px"
              border={true}
              icon={<UploadIcon />}
            />
          </StyledUpload>
          <TextWrapper center alignCenter>
            <StyledH2>Browse for file or Drag and drop</StyledH2>
          </TextWrapper>
          <TextWrapper center alignCenter>
            <SpanText>Size: 10 mb max</SpanText> <Cirlcle />
            <SpanText>Format {format ?? ': .xlsx'}</SpanText>
          </TextWrapper>
        </Wrapper>
      )}
      {showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Control center alignCenter top="5px">
            <AddIcon>
              <Add />
            </AddIcon>
            <UploadText>Upload File</UploadText>
          </Control>
        </StyledUpload>
      )}
      {showButtonUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Button.Primary text="Change" height={'32px'} />
        </StyledUpload>
      )}
    </Fragment>
  )
}

export default Uploader